import LegalRepresentativesFormContent from './LegalRepresentativeFormContent'

export default LegalRepresentativesFormContent
